export const crmOverviewArticle = {
  title: 'Customer CRM: Overview Dashboard',
  slug: 'crm-overview-dashboard',
  content: `Customer CRM: Overview Dashboard

Use the Overview tab to get a snapshot of your CRM and jump into key workflows.

1) Metrics at a glance
- The top of the CRM hub shows workspace metrics like total contacts, active companies, and open deals value.
- Use these metrics to spot changes in pipeline volume or engagement.

2) Quick access cards
- The Overview tab highlights quick entry points for Contacts, Companies, Deals, and Activities.
- Use these cards to jump directly into the area you need without switching tabs manually.

3) Import data
- Use the Import action on the Overview tab to load contacts, companies, and deals via CSV.
- Download the provided template to match required fields before uploading.

4) Recommended setup
- The Overview tab lists setup steps so your CRM data stays complete and usable.
- Complete steps like adding your first contacts and companies before building your pipeline.
`,
};
